import { Flex, Text } from '@theme-ui/components'
import React from 'react'
import SEO from '../components/seo'
import FeatureList from '../components/homepage/features/FeatureList'
import Layout from '../components/layout'
import './404.css'
import DashboardTemplate from '../components/common/sectionTemplate/DashboardTemplate'
import { GET_FEATURES_DATA } from '../components/homepage/Dashboard'
import { useStaticQuery } from 'gatsby'

const NotFoundPage = () => {
  const { contentfulPageLayout } = useStaticQuery(GET_FEATURES_DATA)
  const contentfulFeatureCardSection = contentfulPageLayout?.contentModules?.filter(
    e => Object.keys(e).length !== 0
  )[0]
  const { cardCollection } = contentfulFeatureCardSection
  const featureCards = cardCollection?.card
  return (
    <Layout>
      <SEO title="404: Not found" />
      <DashboardTemplate>
        <Flex sx={{ mb: 7, flexDirection: 'column' }}>
          <Text variant="h3" as="h3">
            The page you&#39;re looking for couldn&#39;t be found.
          </Text>
          <p>What would you like to do today?</p>
        </Flex>
        <FeatureList featureCards={featureCards} />
      </DashboardTemplate>
    </Layout>
  )
}

export default NotFoundPage
